import React from 'react'

const ArtistComments = ({ artists, onEdit }) => {
  const artistsWithComments = artists.filter(artist => artist.comment && artist.name.trim())

  if (artistsWithComments.length === 0) return null

  return (
    <div className="mt-4">
      <h4 className="text-sm font-medium text-gray-200 mb-3">💬 Artist Comments</h4>
      <div className="space-y-2">
        {artistsWithComments.map((artist, index) => {
          const actualIndex = artists.findIndex(a => a.name === artist.name)

          return (
            <div key={index} className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-3">
              <div className="flex items-start gap-3">
                <span className="text-blue-300 font-medium">{artist.name}:</span>
                <span className="text-blue-200 italic flex-1">{artist.comment}</span>
                <button
                  type="button"
                  onClick={() => onEdit(actualIndex)}
                  className="text-blue-400 hover:text-blue-300 transition-colors"
                  title="Edit artist details"
                >
                  ✏️
                </button>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default ArtistComments